import axios from 'axios';

// API Base URL - Backend API endpoint
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:53508';

// File Base URL - Static files (images, documents) URL
// API üzerinden statik dosyalara erişim (UseStaticFiles middleware ile)
export const FILE_BASE_URL = process.env.REACT_APP_FILE_URL || 'http://localhost:53508';

export const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
